export const REPORT_JOB_STATUSES = {
    PENDING: 'pending',
    CANCELLED: 'cancelled',
    FAILED: 'failed',
    COMPLETED: 'completed',
    PROCESSING: 'processing',
};
